export default "__VITE_ASSET__27c314fe__"